<div
	class="cf_show_more_less"
	[innerHtml]="content | nl2br"
	[ngStyle]="styles"
	#contentElement
></div>
<div
	class="cf_show_more_less-show-button"
	*ngIf="isOverflown && !isShowingMore"
	(click)="showMore()"
>
	Show More
</div>
<div
	class="cf_show_more_less-show-button"
	*ngIf="isOverflown && isShowingMore"
	(click)="showLess()"
>
	Show Less
</div>
